import { getCreditLookup } from "../../../../services/requests/billing/dewar-billing-requests";
import { FormItemType } from "../../../UI/view/component-map";
import { DataSource } from "../../../UI/view/data-source";
import { FormView } from "../../../UI/view/form-view";
import { initListView, ListView } from "../../../UI/view/list-view";
import { initView } from "../../../UI/view/view";

export const creditLookupDS = {
  name: 'creditLookupDS',
  entityRequest: getCreditLookup,
  entityRequestArgs: ({ getValues }) => {
    const cst = getValues('cst');
    if (cst) {
      return { cst };
    }
  }
} as DataSource;

export const creditLookupList = {
  noGlobalFilterPadding: true,
  hideGlobalFilter: true,
  columns: [
    {
      Header: 'CST',
      accessor: 'cst',
      defaultSort: true,
    },
    {
      Header: 'Expires Month',
      accessor: 'month',
    },
    {
      Header: 'Expires Year',
      accessor: 'year',
    },
    {
      Header: 'Card Holder Name',
      accessor: 'cardHolderName',
    },
    {
      Header: 'Card Type',
      accessor: 'cardType',
    },
    {
      Header: 'Warning',
      accessor: 'warning',
    },
  ]
} as ListView;

export const CreditLookupList = initListView(creditLookupList, creditLookupDS, (state) => [state.creditLookupDS.current.data].filter(Boolean));

export const creditLookupView = {
  items: [
    {
      type: FormItemType.fieldset,
      label: 'Credit Card Lookup',
      items: [
        {
          type: FormItemType.row,
          style: { marginBottom: '20px' },
          items: [
            {
              type: FormItemType.label,
              label: 'CST',
              fitToContent: true,
            },
            {
              type: FormItemType.text,
              width: 400,
              name: 'cst'
            },
            {
              type: FormItemType.button,
              label: 'Lookup Credit Card',
              fitToContent: true,
              handler: ({ methods: {loadEntity} }) => loadEntity()
            }
          ]
        },
        {
          type: FormItemType.label,
          label: 'Credit Card Info',
        },
        {
          type: FormItemType.customComponent,
          component: CreditLookupList
        }
      ]
    }
  ]
} as FormView;

export const CreditLookupView = initView({ form: creditLookupView, dataSource: creditLookupDS });